<template>
  <v-container data-cy="dialog-cookie-consent">
    <v-bottom-sheet v-model="sheet">
      <v-sheet class="text-center" height="200px">
        <v-btn
          data-cy="button-cookie-consent"
          class="mt-6"
          text
          color="primary"
          @click="saveLocalStorage"
        >{{ $t('Allow cookies') }}</v-btn>
        <div
          class="py-3"
          data-cy="text-cookie-consent"
        >{{ $t('Your experience on this site will be improved by allowing cookies.') }}</div>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
export default {
  name: "CookieConsent",
  data() {
    return {
      sheet:
        localStorage.getItem("cookie-consent") == null || "" || undefined
          ? true
          : false,
    };
  },
  methods: {
    saveLocalStorage() {
      this.sheet = false;
      localStorage.setItem("cookie-consent", true);
    },
  },
};
</script>